define('models/InstagramCategoryModel',['underscore', 'ObjectModel', 'app', 'models/InstagramPostCollection'], function (_, ObjectModel, app, InstagramPostCollection) {
    var InstagramCategoryModelPrototype = {

        name: 'InstagramCategoryModel',
        idAttribute: 'id_insta_display_category',
        route: 'apiInstagramCategoryModel',
        initialize: function () {
            ObjectModel.prototype.initialize.apply(this, arguments);
        },

        getPosts:function(){
            var model =this,
                instagramPostCollectionAttr = 'instagramPostCollection',
                posts = model.get(instagramPostCollectionAttr);
            if(!posts){
                // instancie la collection de posts
                posts = new InstagramPostCollection();
                _(model.get('posts')).each(function(id_insta_post){
                    var post = app.getInstagramPost(id_insta_post);
                    if(post){
                        posts.add(post);
                    }
                });
                model.set(posts);
            }
            return posts;
        }
    };

    return ObjectModel.extend(InstagramCategoryModelPrototype);
});
